/* eslint-disable react-hooks/exhaustive-deps */
import * as THREE from "three";
import React, { useMemo, useState } from "react";

import { const_var, params } from "../../../../../../../redux/reducers/reducer";

import { extrudeSettings } from "../../../../../../../utils/Functions";
import { MaterialTrim } from "../../../../../CustomMaterial";

const TrimModel = () => {
    const [overHangLength, setOverHangLength] = useState(0);

    const trimThickness = 0.2;
    const trimOffsetHeight = (params.b_l_t_r_pF / 12) * trimThickness;
    const Temp_F_p_w = params.leanF_p_w - 0.3;

    const roofSideTrimModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(0, 0);
        model.lineTo(0, trimThickness);
        model.lineTo(trimThickness, trimThickness - trimOffsetHeight);
        model.lineTo(trimThickness,  -trimOffsetHeight);
        model.closePath();

        return model;
    }, [params.b_l_t_r_pF, params.leanF_p_d, trimOffsetHeight]);

    const roofFrontTrimModel = useMemo(() => {
        let regularHeight;
        if(params.p_r_s === 1) regularHeight = const_var.roofRegularDst * 2;
        else regularHeight = 0
        const trimRegularOffset = 0.2

        const model = new THREE.Shape();
        if (params.p_r_s === 1) {
            model.moveTo(-(params.leanF_p_w / 2 + trimRegularOffset) + trimThickness, 0.1);
            model.lineTo(-(params.leanF_p_w / 2 + trimRegularOffset) + trimThickness, const_var.roofRegularDst + trimThickness / 2);
            model.quadraticCurveTo(-(params.leanF_p_w / 2 + trimRegularOffset) + trimThickness, const_var.roofRegularDst * 1.9 + (const_var.roofRegularDst * params.b_l_t_r_pF / 12) / 10, -(params.leanF_p_w / 2 + trimRegularOffset) + trimThickness / 2 + const_var.roofRegularDst, const_var.roofRegularDst * 2 + const_var.roofRegularDst * params.b_l_t_r_pF / 12);
            model.lineTo(0, (params.b_l_t_r_pF / 12) * (params.leanF_p_w / 2 + trimRegularOffset) + regularHeight);
            model.lineTo((params.leanF_p_w / 2 + trimRegularOffset) - trimThickness / 2 - const_var.roofRegularDst, const_var.roofRegularDst * 2 + const_var.roofRegularDst * params.b_l_t_r_pF / 12);
            model.quadraticCurveTo((params.leanF_p_w / 2 + trimRegularOffset) - trimThickness, const_var.roofRegularDst * 1.9 + (const_var.roofRegularDst * params.b_l_t_r_pF / 12) / 10, (params.leanF_p_w / 2 + trimRegularOffset) - trimThickness, const_var.roofRegularDst + trimThickness / 2);
            model.lineTo((params.leanF_p_w / 2 + trimRegularOffset) + 0.005 - trimThickness, 0.1);
            
            model.lineTo((params.leanF_p_w / 2 + trimRegularOffset) + 0.005, 0.1);
            model.lineTo((params.leanF_p_w / 2 + trimRegularOffset), trimThickness + const_var.roofRegularDst);
            model.quadraticCurveTo((params.leanF_p_w / 2 + trimRegularOffset), trimThickness + const_var.roofRegularDst * 1.9 + (const_var.roofRegularDst * params.b_l_t_r_pF / 12) / 10, (params.leanF_p_w / 2 + trimRegularOffset) - const_var.roofRegularDst, trimThickness + const_var.roofRegularDst * 2 + const_var.roofRegularDst * params.b_l_t_r_pF / 12);
            model.lineTo(0, (params.b_l_t_r_pF / 12) * (params.leanF_p_w / 2 + trimRegularOffset) + trimThickness + regularHeight + 0.005);
            model.lineTo(-(params.leanF_p_w / 2 + trimRegularOffset) + const_var.roofRegularDst, trimThickness + const_var.roofRegularDst * 2 + const_var.roofRegularDst * params.b_l_t_r_pF / 12);
            model.quadraticCurveTo(-(params.leanF_p_w / 2 + trimRegularOffset), trimThickness + const_var.roofRegularDst * 1.9 + (const_var.roofRegularDst * params.b_l_t_r_pF / 12) / 10, -(params.leanF_p_w / 2 + trimRegularOffset), trimThickness + const_var.roofRegularDst)
            model.lineTo(-(params.leanF_p_w / 2 + trimRegularOffset), 0.1);
            model.closePath()
        } else if (params.p_r_s === 2 || params.p_r_s === 3) {
            model.moveTo(-Temp_F_p_w / 2 - trimThickness, -trimThickness);
            model.lineTo(-Temp_F_p_w / 2 - trimThickness, 0);
            model.lineTo(0, params.b_l_t_r_pF / 12 * (Temp_F_p_w / 2 + 0.2));
            model.lineTo(Temp_F_p_w / 2 + trimThickness, (-params.b_l_t_r_pF / 12) * 0.02);
            model.lineTo(Temp_F_p_w / 2 + trimThickness, -trimThickness);
            model.lineTo(0, params.b_l_t_r_pF / 12 * (Temp_F_p_w / 2 + 0.2)  - trimThickness);
            model.closePath();
        }

        return model;
    }, [params.b_l_t_r_pF, Temp_F_p_w, params.p_r_s, overHangLength]);

    useMemo(() => {
        if (params.p_r_s === 2 || params.p_r_s === 1) {
            if(params.p_r_s === 2) setOverHangLength(0.75); else setOverHangLength(0.25);

        } else if (params.p_r_s === 3) {
            if (params.o_v_h_n_g_e === true) {
                setOverHangLength(0.9)
            } else {
                setOverHangLength(0.75)
            }
        }
    }, [params.p_r_s, params.o_v_h_n_g_e])

    return (
        <>
            {params.p_r_s !== 1 &&
                <>
                    <mesh name='non-loft-roof-trim-left' position={[-(Temp_F_p_w / 2 + trimThickness - 0.05), params.leanF_p_h - 0.005 - trimThickness, (params.p_d / 2 + params.leanF_p_d + trimThickness)]} rotation={[0, Math.PI, 0]}>
                        <extrudeGeometry args={[roofSideTrimModel, extrudeSettings(params.leanF_p_d)]} />
                        <MaterialTrim visibleSection={"gableFrontLean"} />
                    </mesh>
                
                    <mesh name='non-loft-roof-trim-right' position={[Temp_F_p_w / 2 + trimThickness - 0.05, params.leanF_p_h - 0.005 - trimThickness, params.p_d / 2 + trimThickness]} >
                        <extrudeGeometry args={[roofSideTrimModel, extrudeSettings(params.leanF_p_d)]} />
                        <MaterialTrim visibleSection={"gableFrontLean"} />
                    </mesh>
                </>
            }
            <mesh name='non-loft-roof-trim-front' position={[0, params.leanF_p_h - ((params.p_r_s === 1) ? 0.12 : 0.013), (params.p_d / 2 + params.leanF_p_d + ((params.p_r_s === 1) ? 0.5 : trimThickness))]} rotation={[0, Math.PI, 0]}>
                <extrudeGeometry args={[roofFrontTrimModel, extrudeSettings(trimThickness)]} />
                <MaterialTrim visibleSection={"gableFrontLean"} />
            </mesh>
        </>
    );
};

export default TrimModel;
